import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(
  theme => ({
    accountLabels: {
      cursor: "pointer",
      paddingRight: 10
    },
    accountList: {
      gridRowGap: 0,
      padding: "0px !important",
      userSelect: "none"
    },
    accountListItem: {
      "&:hover": {
        backgroundColor: "#F4F8FF",
        borderRadius: 6,
        transition: `background-color ${theme.transitions.duration.shorter}ms`
      },
      display: "flex",
      justifyContent: "space-around",
      padding: "2px 2px 2px 10px"
    },
    emailText: {
      fontSize: "0.65rem",
      maxWidth: 200,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    hiddenTrashButton: {
      opacity: 0,
      transition: `opacity ${theme.transitions.duration.shorter}ms`
    },
    nameText: {
      fontSize: "0.9rem",
      fontWeight: 600,
      maxWidth: 200,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    switchAccountLabel: {
      color: "#b4b1b1",
      fontSize: "0.72rem",
      margin: 5
    },
    trashButton: {
      "&:hover": {
        background: "none"
      },
      color: "#485bff"
    },
    trashIcon: {
      minWidth: "auto",
      padding: "0 2px"
    }
  }),
  {
    name: "SavedAcountsList"
  }
);
